import Subtitle from "components/Subtitle/subtitle.component";
import Table from "components/Table/table.component";
import Input from "components/Input/input.component";
import Button from "components/Button/button.component";
import VisualizarPdrPrestacao from "./visualizarPdrPrestacao";
import { PRESTACAO_CONTAS_PERMISSIONS } from "constants/index";
import React, { Component } from 'react';
import { Accordion, AccordionItem } from "react-sanfona";
import FormatHelper from 'utils/formatHelper';

export default class  HistoricoPDRAnalisePrestacao extends Component {
  state = {
    showBaseModal: false,
		codemodal: false,
		isNotificacaoDacaOpen: false,
		itemVisualizar: {}
	};

  showModal = (item) => {
    this.setState({ showBaseModal: true, itemVisualizar: item });
  }
  
  hideModal = () => {
    this.setState({ showBaseModal: false, itemVisualizar: {} });
	}

	onIsNotificacaoDaca = () => {
    this.setState({ isNotificacaoDacaOpen: !this.state.isNotificacaoDacaOpen});
	}

	createModalVisualizar = () =>
	this.state.showBaseModal && (
		<VisualizarPdrPrestacao
			isOpen={this.state.showBaseModal}
			item={this.state.itemVisualizar}
			handleClose={this.hideModal}
			isNotificacaoDaca={this.state.isNotificacaoDacaOpen}
		/> 
	);


	getColumnsRecursos = () =>{
		return [
			{ id: 0, title: "Meta", property: "nomeMeta" },
			{ id: 1, title: "Nº de Beneficiários", property: "numBeneficiados" },
			{ id: 2, title: "Nº de Dias ", property: "numDias" },
			{ id: 3, title: "Valor Total (R$) ", property: "valor" }
		];
	}

	getColumnsHumanitario = () =>{
		return [
			{ id: 0, title: "Tipo", property: "tipoDescricao" },
			{ id: 1, title: "Nº de Desabrigados", property: "numDesabrigados" },
			{ id: 2, title: "Nº de Afetados ", property: "numAfetados" },
			{ id: 3, title: "Período ", property: "periodo" },
			{ id: 4, title: "Quantidade ", property: "quantidade" }
		];
	}

	getColumnsNotificacaoDacaHumanitario = () =>{
		return [
			{ id: 0, title: "Tipo", property: "tipoDescricao" },
			{ id: 1, title: "Quantidade ", property: "quantidade" }
		];
	}

	getColumnsDocumentos = () =>{
		return [
			{ id: 0, title: "Documento", property: "nomeDocumento" },
			{ id: 1, title: "Modelo", property: "modelo" }
		];
	}

	getActions = () =>{
		return [
			{
				id: 0,
				name: "Visualizar",
				icon: "fas fa-eye",
				action: item => this.showModal(item)
			}
		];
	}

	getActionsDocumentos = () =>{
		return [
			{
				id: 0,
				name: "Baixar",
				icon: "fas fa-download",
				action: item => this.downloadFile(item.arquivo, item.nomeDocumento)
			}
		];
	}

	 getTipoSolicitacao = (codigoTipoSolicitacao) => {
		switch(codigoTipoSolicitacao) {
			case 1:
				return 'Kits de Assistência Humanitária';
			case 2:
					return 'Recursos para Ações de Assistência';
			case 3:
					return 'Recursos para Ações de Restabelecimento';
			default:
				return ' -- ';
		}
	}

	getListaRecursosFormatada = (recursosList) => {
		let recursosListModificada = [];

		recursosList.forEach(element => {
			let item = Object.assign({}, element);
			item.valor = FormatHelper.formatMoneyNumber(item.valor);
			recursosListModificada.push(item);
		});

		return recursosListModificada;
	}

	downloadFile = (documento, nome) => {
		let link = document.createElement('a');
		link.href = documento;
		link.download = nome;
		link.click();
	};
	
	render() {
		const {
			props: {
				historicos
			},
		} = this;
    return (
			<>
				{this.createModalVisualizar()}
				<Subtitle>Saída PDR</Subtitle>
				<hr />
				<Accordion className="mb-1">
					<AccordionItem title="PDR" titleTag="h5">
						<div className='row'>
							<label className='col-4'>
								<b>Responsável:</b>
								{' '}
								{historicos.pdr.responsavel || ' -- '}
							</label>
							<label className='col-4'>
								<b>Data/hora:</b>
								{historicos.pdr.dataCriacao || ' -- '}
							</label>
							<label className='col-4'>
								<b>Nº do PDR:</b>
								{' '}
								{historicos.pdr.codigo || ' -- '}
							</label>
						</div>
		
						<div className='row'>
							<label className='col-4'>
								<b>Nº de Óbitos:</b>
								{' '}
								{historicos.historicoDaca.ocorrencia.danosHumanos.quantidadeObitos || ' -- '}
							</label>
							<label className='col-4'>
								<b>Nº de Feridos:</b>
								{' '}
								{historicos.historicoDaca.ocorrencia.danosHumanos.quantidadeFeridos || ' -- '}
							</label>
							<label className='col-4'>
								<b>Nº de Desabrigados:</b>
								{' '}
								{historicos.historicoDaca.ocorrencia.danosHumanos.quantidadeDesabrigados || ' -- '}
							</label>
						</div>
		
						<div className='row'>
							<label className='col-4'>
								<b>Nº de Desalojados:</b>
								{' '}
								{historicos.historicoDaca.ocorrencia.danosHumanos.quantidadeDesalojados ||' -- '}
							</label>
							<label className='col-8'>
								<b>Nº de Outros Afetados:</b>
								{' '}
								{historicos.historicoDaca.ocorrencia.danosHumanos.quantidadeAfetados || ' -- '}
							</label>
						</div>
		
						<div className='row' style={{marginTop: '10px'}}>
							<label className='col-12'>
								<b>Tipo de solicitação do PDR:</b>
								{' '}
								{this.getTipoSolicitacao(historicos.pdr.codigoTipoAssistencia)}
							</label>
						</div>
		
						<div>
							{historicos.pdr.codigoTipoAssistencia === 1
							?
							<div className='row'style={{marginTop: '10px'}}>
								<label className='col-12'>
									<b>Lista de Kits de Assistência Humanitária:</b>
									{' '}
								</label>
								<div className='col-12'>
								<Table
									columns={this.getColumnsHumanitario()}
									data={historicos.pdr.pdrAssistenciaHumanitaria}
									emptyMessage="Não há registros cadastrados."
									emptyColSpan={this.getColumnsHumanitario().length + 1}
									permission={[PRESTACAO_CONTAS_PERMISSIONS.VISUALIZAR]}
								/>
								</div>
							</div>
						:
							<div className='row'style={{marginTop: '10px'}}>
								<label className='col-12'>
									<b>Lista de Recursos para Ações de Restabelecimento:</b>
									{' '}
								</label>
								<div className='col-12'>
										<Table
											acoesSingleButton
											columns={this.getColumnsRecursos()}
											actions={this.getActions()}
											data={this.getListaRecursosFormatada(historicos.pdr.pdrAssistenciaRecurso)}
											emptyMessage="Não há registros cadastrados."
											emptyColSpan={this.getColumnsRecursos().length + 1}
											permission={[PRESTACAO_CONTAS_PERMISSIONS.VISUALIZAR]}
										/>
								</div>
							</div>
							}
						</div>
		
						<div className='row'style={{marginTop: '10px'}}>
							<label className='col-12'>
								<b>Documentos:</b>
								{' '}
							</label>
						</div>
						<div className='row'style={{marginTop: '10px'}}>	
							<div className='col-12'>
								<Table
									acoesSingleButton
									columns={this.getColumnsDocumentos()}
									actions={this.getActionsDocumentos()}
									data={historicos.pdr.listaDocumentos}
									emptyMessage="Não há registros cadastrados."
									emptyColSpan={this.getColumnsDocumentos().length + 1}
									permission={[PRESTACAO_CONTAS_PERMISSIONS.VISUALIZAR]}
								/>
							</div>
						</div>
					</AccordionItem>
		
					<AccordionItem title="Análise Regional do PDR" titleTag="h5">
						<div className='row'>
							<label className='col-4'>
								<b>Responsável:</b>
								{' '}
								{historicos.pdr.tramite.usuario || ' -- '}
							</label>
							<label className='col-4'>
								<b>Data/hora:</b>
								{' '}
								{historicos.pdr.tramite.dataTramite || ' -- '}
							</label>
							<label className='col-4'>
								<b>Parecer:</b>
								{' '}
								{historicos.pdr.tramite.parecer || ' -- '}
							</label>
						</div>
		
						<div className='row'>
							<div className='col-md-12'>
								<label>
									<b>Justificativa:</b>
								</label>
								<div className='form-group'>
									<Input
										type='textarea'
										name='descricao'
										disabled={true}
										value={historicos.pdr.tramite.justificativa || ' -- '}
										rows='3'
										maxLength='255'
									/>
								</div>
							</div>
						</div>
		
						<div className='row'>
							<label className='col-12'>
								<b>Anexo:</b>
							</label>
						</div>
						<div  style={{ padding:'1% 0 1% 0', borderTop:'2px solid gray', borderBottom: '2px solid gray', marginLeft: '0px', marginRight: '0px'}}>
							{historicos.pdr.tramite.arquivo && historicos.pdr.tramite.arquivo.length > 0
							?
								<div className='row'>
									<label className='col-6'>
									{historicos.pdr.tramite.nomeArquivo != null
								? historicos.pdr.tramite.nomeArquivo : ' -- '}
									</label>
									<div className='col-6'>
										<Button
											onClick={() => this.downloadFile(historicos.pdr.tramite.arquivo, historicos.pdr.tramite.nomeArquivo)}
											className='float-right'
											primary
											type='button'
											text='Download'
											icon='fas fa-download'
										/>
									</div>
								</div>
								:
								<SemInformacoes />
							}
						</div>
					</AccordionItem>
		
					<AccordionItem title="Notificação DACA" titleTag="h5" onExpand={() => this.onIsNotificacaoDaca()} onClose={() => this.onIsNotificacaoDaca()}>
					<div className='row'>
							<label className='col-6'>
								<b>Responsável:</b>
								{' '}
								{historicos.pdr.notificacaoMunicipio.responsavelNotificacao || ' -- '}
							</label>
							<label className='col-6'>
								<b>Data/hora:</b>
								{' '}
								{historicos.pdr.notificacaoMunicipio.dataNotificacao || ' -- '}
							</label>
						</div>
		
						<div className='row'>
							<div className='col-md-12'>
								<label>
									<b>Notificação:</b>
								</label>
								<div className='form-group'>
									<Input
										type='textarea'
										name='descricao'
										disabled={true}
										value={historicos.pdr.notificacaoMunicipio.notificacao || ' -- '}
										rows='3'
										maxLength='255'
									/>
								</div>
							</div>
						</div>
		
						<div>
							{historicos.pdr.codigoTipoAssistencia === 1
							?
							<div className='row'style={{marginTop: '10px'}}>
								<label className='col-12'>
									<b>Lista de Kits de Assistência Humanitária:</b>
									{' '}
								</label>
								<div className='col-12'>
								<Table
									columns={this.getColumnsNotificacaoDacaHumanitario()}
									data={historicos.pdr.pdrAssistenciaHumanitaria}
									emptyMessage="Não há registros cadastrados."
									emptyColSpan={this.getColumnsNotificacaoDacaHumanitario().length + 1}
									permission={[PRESTACAO_CONTAS_PERMISSIONS.VISUALIZAR]}
								/>
								</div>
							</div>
						:
							<div className='row'style={{marginTop: '10px'}}>
								<label className='col-12'>
									{historicos.pdr.codigoTipoAssistencia === 2
										?	<b>Lista de Recursos para Ações de Assistência:</b> : <b>Lista de Recursos para Ações de Restabelecimento:</b> }
									{' '}
								</label>
								<div className='col-12'>
										<Table
											acoesSingleButton
											columns={this.getColumnsRecursos()}
											actions={this.getActions()}
											data={this.getListaRecursosFormatada(historicos.pdr.pdrAssistenciaRecurso)}
											emptyMessage="Não há registros cadastrados."
											emptyColSpan={this.getColumnsRecursos().length + 1}
											permission={[PRESTACAO_CONTAS_PERMISSIONS.VISUALIZAR]}
										/>
								</div>
							</div>
							}
						</div>
					</AccordionItem>
		
					<AccordionItem title="Termo de Recebimento" titleTag="h5">
						<div className='row'>
							<label className='col-6'>
								<b>Responsável:</b>
								{' '}
								{historicos.pdr.termoRecebimento.responsavelTermoRecebimento || ' -- '}
							</label>
							<label className='col-6'>
								<b>Data/hora:</b>
								{' '}
								{historicos.pdr.termoRecebimento.dataTermoRecebimento || ' -- '}
							</label>
						</div>
		
						<div className='row'>
							<label className='col-12'>
								<b>Termo de recebimento:</b>
							</label>
						</div>
						<div style={{ padding:'1% 0 1% 0', borderTop:'2px solid gray', borderBottom: '2px solid gray', marginLeft: '0px', marginRight: '0px'}}>
							{historicos.pdr.termoRecebimento.documentoTermo &&historicos.pdr.termoRecebimento.documentoTermo.arquivo 
							?
								<div className='row'>
									<label className='col-6'>
									{ historicos.pdr.termoRecebimento.documentoTermo.nomeDocumento || ' -- '}
									</label>
									<div className='col-6'>
										<Button
											onClick={() => this.downloadFile(historicos.pdr.termoRecebimento.documentoTermo.arquivo, historicos.pdr.termoRecebimento.documentoTermo.nomeDocumento)}
											className='float-right'
											primary
											type='button'
											text='Download'
											icon='fas fa-download'
										/>
									</div>
								</div>
								:
								<SemInformacoes />
							}
						</div>
					</AccordionItem>
				</Accordion>
			</>
		);
	}
}

const SemInformacoes = () => (
	<span>Não existem informações a serem exibidas.</span>
);
